export default {
  title: 'Job Template Management',
  menu: 'Job Template Management',
  label: {
    companyName: 'Company',
    cnTemplateName: 'Chinese Job Title',
    enTemplateName: 'English Job Title',
    enabledTemplate: 'Enabled Templates',
    disabledTemplate: 'Disabled Templates',
    status: 'Status'
  },
  placeholder: {
    keywords: 'Search job templates by title'
  },
  btn: {
    add: 'Add Template'
  },
  message: {
    confirmEnable: {
      disable: 'Confirm to disable this job template?',
      enable: 'Confirm to enable this job template?'
    }
  }
}
